<template>
  <a-form-model ref="informationForm" :model="form" :rules="rules">
    <a-row :gutter="12">
      <a-col :span="getScreen ? 24 : 12">
        <a-form-model-item
          label="Offering Letter Date"
          prop="offering_letter_date"
        >
          <a-date-picker
            :format="getDefaultDateFormat"
            type="date"
            v-model="form.offering_letter_date"
          />
        </a-form-model-item>
        <a-form-model-item
          label="Offering letter Number"
          prop="offering_letter_number"
        >
          <a-input v-model="form.offering_letter_number"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Financing Type" prop="type_financing">
          <a-radio-group
            :disabled="mode == 'Edit'"
            @change="handleType"
            buttonStyle="solid"
            v-model="form.type_financing"
          >
            <a-radio-button value="FK">KMK</a-radio-button>
            <a-radio-button value="FP">Non KMK</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="Debitur" prop="debitur">
          <a-input v-model="form.debitur"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Credit Schemas" prop="bentuk_kredit">
          <a-select
            placeholder="Choose Credit Schemas"
            v-model="form.bentuk_kredit"
            class="width-full"
            allowClear
            showSearch
          >
            <a-select-option value="Co. Tetap">Co. Tetap</a-select-option>
            <a-select-option value="Co. Menurun">Co. Menurun</a-select-option>
            <a-select-option value="Musyarakah">Musyarakah</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Requirements" prop="keperluan">
          <a-textarea
            :file-list="form.doc_financing"
            v-model="form.keperluan"
            :rows="1"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="Interest Rate" prop="suku_bunga">
          <a-input v-model="form.suku_bunga"></a-input>
        </a-form-model-item>
      </a-col>
      <a-col :span="getScreen ? 24 : 12">
        <a-form-model-item label="Time period" prop="time_period">
          <a-range-picker
            :format="getDefaultDateFormat"
            allowClear
            v-model="form.time_period"
          />
        </a-form-model-item>
        <a-form-model-item label="Number of Facilities" prop="jml_fasilitas">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="form.jml_fasilitas"
            :disabled="type == 'revisi'"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Agunan" prop="angunan">
          <a-input v-model="form.angunan"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Denda / Penalty" prop="denda_penalty">
          <a-input v-model="form.denda_penalty"></a-input>
        </a-form-model-item>
        <a-form-model-item label="Provisi" prop="provisi">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="form.provisi"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Admin Fee" prop="biaya_admin">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="form.biaya_admin"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="File Document" prop="doc_financing">
          <template v-if="mode == 'Create'">
            <a-upload
              accept="*"
              :showUploadList="false"
              :beforeUpload="beforeUpload"
            >
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
            <div class="doc-viewer" v-if="form.doc_financing !== null">
              <a-button
                type="danger"
                ghost
                size="small"
                class="close"
                icon="close"
                @click="handleRemoveDisplay"
              ></a-button>
              <a-icon
                class="icon"
                :type="
                  JSON.parse(JSON.stringify(form.doc_financing.type)) ==
                  'application/pdf'
                    ? 'file-pdf'
                    : JSON.parse(JSON.stringify(form.doc_financing.type)) ==
                      'image/jpeg'
                    ? 'file-image'
                    : 'file'
                "
              />
              <div :class="getScreen ? 'detail mobile' : 'detail'">
                <h4 class="margin-remove m-text-dots">
                  {{ JSON.parse(JSON.stringify(form.doc_financing.name)) }}
                </h4>
                <small>{{
                  JSON.parse(JSON.stringify(form.doc_financing.type))
                }}</small>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="doc-viewer edit">
              <div :class="getScreen ? 'detail mobile' : 'detail'">
                <a-button-group size="small">
                  <a-upload
                    accept="*"
                    :showUploadList="false"
                    :beforeUpload="beforeUpload"
                  >
                    <a-button size="small" icon="upload">
                      Change File
                    </a-button>
                  </a-upload>
                  <a-button
                    @click="handleDisplay"
                    :type="form.doc_financing == null ? '' : 'primary'"
                    :icon="form.doc_financing == null ? 'eye' : 'reload'"
                  ></a-button>
                </a-button-group>
                <h4 class="margin-remove m-text-dots">
                  {{
                    this.form.doc_financing == null
                      ? this.getInformationFinancing.doc_existing
                      : this.form.doc_financing.name
                  }}
                </h4>
              </div>
            </div>
          </template>
        </a-form-model-item>
      </a-col>
    </a-row>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "information",
  props: {
    dataProcessed: {},
    mode: String,
    type: String,
  },
  mixins: [GlobalMethod],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value[0]==null || value[1]==null || value.length==0) {
        callback(new Error("Please pick Time Periode"));
      } else {
        callback();
      }
    };
    return {
      form: {
        offering_letter_date: null,
        offering_letter_number: null,
        debitur: null,
        type_financing: null,
        bentuk_kredit: null,
        denda_penalty: null,
        angunan: null,
        suku_bunga: null,
        keperluan: null,
        time_period: [null, null],
        jml_fasilitas: null,
        provisi: null,
        biaya_admin: null,
        doc_financing: null,
      },
      rules: {
        offering_letter_date: [
          {
            required: true,
            message: "Please pick financing date",
            trigger: "change",
          },
        ],
        offering_letter_number: {
          required: true,
          message: "Please input financing no",
          trigger: "change",
        },
        debitur: {
          required: true,
          message: "Please input debitur",
          trigger: "change",
        },
        type_financing: {
          required: true,
          message: "Please input bentuk kredit",
          trigger: "change",
        },
        bentuk_kredit: {
          required: true,
          message: "Please input bentuk kredit",
          trigger: "change",
        },
        doc_financing: {
          required: this.mode == "Create" ? true : false,
          message: "Please input financing document",
          trigger: "change",
        },
        denda_penalty: {
          required: false,
        },
        angunan: {
          required: false,
        },
        suku_bunga: {
          required: true,
          message: "Please input interest rate",
          trigger: "change",
        },
        keperluan: {
          required: true,
          message: "Please input keperluan",
          trigger: "change",
        },
        time_period: 
          { required: true, validator: validatePass, trigger: "change" },
        
        jml_fasilitas: {
          required: true,
          message: "Number of Facilities is required",
          trigger: "change",
        },
        provisi: {
          required: false,
        },
        biaya_admin: {
          required: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      "getDateTimeStandartFormat",
      "getDefaultDateFormat",
      "getInformationFinancing",
      "getScreen",
    ]),
  },
  watch: {
    getInformationFinancing() {
      this.initialData();
    },
  },
  mounted() {
    this.initialData();
  },
  methods: {
    moment,
    initialData() {
      this.form = {
        offering_letter_date: this.getInformationFinancing.offering_letter_date
          ? this.getInformationFinancing.offering_letter_date
          : null,
        offering_letter_number: this.getInformationFinancing
          .offering_letter_number
          ? this.getInformationFinancing.offering_letter_number
          : null,
        debitur: this.getInformationFinancing.debitur
          ? this.getInformationFinancing.debitur
          : null,
        type_financing: this.getInformationFinancing.type_financing
          ? this.getInformationFinancing.type_financing
          : "FK",
        bentuk_kredit: this.getInformationFinancing.bentuk_kredit
          ? this.getInformationFinancing.bentuk_kredit
          : null,
        denda_penalty: this.getInformationFinancing.denda_penalty
          ? this.getInformationFinancing.denda_penalty
          : null,
        angunan: this.getInformationFinancing.angunan
          ? this.getInformationFinancing.angunan
          : null,
        suku_bunga: this.getInformationFinancing.suku_bunga
          ? this.getInformationFinancing.suku_bunga
          : null,
        keperluan: this.getInformationFinancing.keperluan
          ? this.getInformationFinancing.keperluan
          : null,
        time_period: this.getInformationFinancing.time_period
          ? this.getInformationFinancing.time_period
          : [null, null],
        jml_fasilitas: this.getInformationFinancing.jml_fasilitas
          ? this.getInformationFinancing.jml_fasilitas
          : null,
        doc_financing: this.getInformationFinancing.doc_financing
          ? this.getInformationFinancing.doc_financing
          : null,
        provisi: this.getInformationFinancing.provisi
          ? this.getInformationFinancing.provisi
          : null,
        biaya_admin: this.getInformationFinancing.biaya_admin
          ? this.getInformationFinancing.biaya_admin
          : null,
      };
    },
    handleRef() {
      this.$refs.informationForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        if (
          this.mode == "Edit" &&
          (this.type == "amandemen" || this.type == "revisiwf") &&
          parseFloat(this.form.jml_fasilitas) <
            parseFloat(this.getInformationFinancing.total_penarikan)
        ) {
          this.displayMessageValue(
            "basic-error",
            "Number of Facilities cannot less than Total Penarikan"
          );
          return;
        }

        this.form = {
          ...this.form,
          jkw_start_dt: moment(this.form.time_period[0]).format("YYYY-MM-DD"),
          jkw_end_dt: moment(this.form.time_period[1]).format("YYYY-MM-DD"),
          total_penarikan: this.getInformationFinancing.total_penarikan
        };

        if (
          this.mode == "Edit" &&
          this.dataProcessed.information.doc_existing
        ) {
          this.form.doc_existing = this.dataProcessed.information.doc_existing;
        }

        Event.$emit("dataProcessed", this.form);
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 30) {
        this.displayMessage("large-file-2mb");
      } else if (this.fungsi === "") {
        this.displayMessage("error-emptyDoc");
      } else {
        this.form.doc_financing = file;

        return false;
      }
    },
    handleDisplay() {
      if (this.form.doc_financing !== null) {
        this.form.doc_financing = null;
      } else {
        window.open(this.$serviceUrl + this.getInformationFinancing.url);
      }
    },
    handleRemoveDisplay() {
      this.form.doc_financing = null;
    },
    handleType(value) {
      Event.$emit("setstepRulesDtl", value.target.value == "FP" ? true : false);
    },
  },
};
</script>

<style lang="less" scoped>
.doc-viewer {
  margin-top: 0.5em;
  border: 1px solid darken(white, 10);
  padding: 5px 0;
  min-height: 50px;
  display: flex;
  align-items: flex-end;
  gap: 12px;
  background-color: darken(white, 2);
  position: relative;

  &.edit {
    align-items: center;
    padding: 5px;
    min-height: auto;
    .detail {
      flex: 1;
      flex-direction: row;
      justify-content: space-between;
      h4 {
        text-align: right;
      }

      &.mobile {
        flex-direction: column;
        justify-content: flex-start;
        gap: @padding / 2;
        h4 {
          text-align: left;
        }
      }
    }
  }

  .icon {
    font-size: 3.5em;
    color: orangered;
  }

  .detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.5em;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}
</style>
